import { Outlet, useLocation } from "react-router";
import { Toaster, TooltipProvider } from "~/components/ui";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

const labelForSegment = (segment: string): string =>
  segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, " ");

// Structural segments that have no landing page of their own. They render as plain text, not links.
const NON_ROUTABLE_SEGMENTS = new Set(["area-input", "admin"]);
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function V2Layout() {
  const location = useLocation();

  // V2 is served at the root path. Accumulate path segments so each linkable crumb
  // except the last is a working link.
  const segments = location.pathname.split("/").filter(Boolean);

  // The first id in the trail is the primary record (e.g. recordId -> the record's area view) and
  // links; ids nested under it (e.g. geoItemId) are not standalone destinations. Structural
  // prefixes (area-input / admin) have no landing page and never link.
  const firstIdIndex = segments.findIndex((s) => UUID_RE.test(s));
  const crumbs: { label: string; to: string; linkable: boolean }[] = [
    { label: "Dewey", to: "/", linkable: true },
    ...segments.map((s, i) => ({
      label: labelForSegment(s),
      to: `/${segments.slice(0, i + 1).join("/")}`,
      linkable: !NON_ROUTABLE_SEGMENTS.has(s) && (!UUID_RE.test(s) || i === firstIdIndex),
    })),
  ];

  return (
    <TooltipProvider delayDuration={200}>
      <div data-app="v2" className="grid min-h-screen grid-cols-[var(--sidenav-w)_1fr] bg-bg-page">
        <Sidebar />
        <div className="min-w-0">
          <Topbar crumbs={crumbs} />
          <Outlet />
        </div>
        <Toaster />
      </div>
    </TooltipProvider>
  );
}
